import { Dashboard, UnitsView } from '@/components';

export const UnitsViewPage = () => (
  <Dashboard openLogIn>
    <UnitsView />
  </Dashboard>
);
